/**
 * Copyright 2026 Bluecircle Technologies Pvt Limited. All rights reserved.
 *
 * This software and its source code are the proprietary and confidential
 * intellectual property of Bluecircle Technologies Pvt Limited. Unauthorized
 * copying, reproduction, distribution, modification, public display, or use
 * of this software, in whole or in part, is strictly prohibited without the
 * prior written permission of Bluecircle Technologies Pvt Limited.
 *
 * Portions derived from Grist (Copyright Grist Labs), used under the Apache
 * License, Version 2.0. See the NOTICE file for details.
 */

import moment from "moment";

/**
 * Given a UTC Date ISO 8601 string (the doc updatedAt string), gives a reader-friendly
 * relative time to now - e.g. 'yesterday', '2 days ago'.
 */
export function getTimeFromNow(utcDateISO: string): string;
/**
 * Given a unix timestamp (in milliseconds), gives a reader-friendly
 * relative time to now - e.g. 'yesterday', '2 days ago'.
 */
export function getTimeFromNow(ms: number): string;
export function getTimeFromNow(isoOrTimestamp: string | number): string {
  const time = moment.utc(isoOrTimestamp);
  const now = moment();
  const diff = now.diff(time, "s");
  if (diff < 0 && diff > -60) {
    // If the time appears to be in the future, but less than a minute
    // in the future, chalk it up to a difference in time
    // synchronization and don't claim the resource will be changed in
    // the future.  For larger differences, just report them
    // literally, there's a more serious problem or lack of
    // synchronization.
    return now.fromNow();
  }
  return time.fromNow();
}
